import React, {PureComponent} from "react"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {Query} from "@irati/utils/apollo"
import {InspirationList} from "@irati/types"
import {gql} from "@irati/utils/gql"

const query = gql`
  query Inspirations($tenantId: String) {
    inspirations(tenantId: $tenantId) {
      results {
        desc
        id
        isCompanyValue
        suggestion
        tag
        title
        trophy {
          alt
          href
        }
      }
    }
  }
`

export interface InspirationsData {
  data: {
    inspirations: InspirationList
  }
}

interface Props {
  variables?: {
    tenantId: string
  }
}

class TypedQuery extends Query<InspirationsData> {}

export default class InspirationsQuery extends PureComponent<Props> {
  render() {
    return <QueryComponent {...this.props} QueryComponent={TypedQuery} query={query} />
  }
}
